import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

import { SiteImagesQueryQuery } from "../generated/graphql-types"

// https://note.com/hisho_official/n/nb262eab01c77

type ImageProps = {
  name: string,
};

export default ({ name }: ImageProps) => {
  const data = useStaticQuery<SiteImagesQueryQuery>(graphql`
    query SiteImagesQuery {
      allFile(filter: { ext: { regex: "/(png|jpg)/" } }) {
        nodes {
          relativePath
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `);

  let index = -1;
  if(data?.allFile?.nodes) {
    for(let i = 0; i < data.allFile.nodes.length; i++) {
      if(data.allFile.nodes[i].relativePath === name) {
        index = i;
        break;
      }
    }
  }

  if(index < 0 || !data.allFile.nodes[index]?.childImageSharp?.fluid) {
    return <div>Picture not found</div>
  }

  return <Img fluid={data.allFile.nodes[index].childImageSharp.fluid} />
}
